export default __webpack_public_path__ + "static/media/front.30df8f96.png";